




































































import Vue, { PropType, VueConstructor } from "vue";
import ChoseLicense from "@/components/organisms/wizard/ChoseLicense.vue";
import NewLicense from "@/components/organisms/wizard/NewLicense.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import { LicenseDetail } from "@/models/license";
import { DeviceConfiguration } from "@/models/deviceConfiguration";
import WizardService from "@/services/wizardService";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "StepLicense",
  mixins: [wizardStepsMixin],
  props: {
    deviceConfiguration: {
      type: Object as PropType<DeviceConfiguration>,
    },
  },
  data() {
    return {
      licenseMode: undefined as string | undefined,
      license: undefined as LicenseDetail | undefined,
    };
  },
  components: { VaButton, NewLicense, ChoseLicense },
  computed: {},
  watch: {
    license: function () {
      this.$emit("onChoseLicense", this.license);
    },
  },
  methods: {
    associateLicense(lic: LicenseDetail) {
      this.license = lic;
    },
    async activateSeat() {
      if (this.deviceConfiguration.licenseKey) {
        this.onNext();
      } else if (this.license) {
        try {
          this.loading = true;
          await WizardService.reserveSeat(
            this.deviceConfiguration.deviceConfigurationId,
            this.license.licensePackageId
          );
          this.onNext();
        } catch (e) {
          this.handleError(e);
        } finally {
          this.loading = false;
        }
      }
    },
  },
});
